// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1afCL","title":"Info_title__3-9K9","selects":"Info_selects__2OVAc","requiredAsterisk":"Info_requiredAsterisk__22mGo"};